// migration-allow(family-importers): takes over the share-chat call previously done inside use-share-evidence-chat
import { useMutateShareChat } from '@/hooks/mutation/useMutateShareChat';

export function useShareChatHost() {
  const { mutateAsync: shareChat, isPending: isCreatingShare } = useMutateShareChat();

  return { shareChat, isCreatingShare };
}
